import ProductCarouselContent from '@/components/sections/builder/elements/body/product-carousel/client-content';
import SkeletonProductCarousel from '@/components/sections/builder/elements/body/product-carousel/skeleton';
import { ElementProps } from '@/components/sections/builder/types';
import { Suspense } from 'react';

export default function ElementContent({
  element,
  preview,
  host,
  theme,
  storeSetting,
}: ElementProps) {
  return (
    <Suspense
      fallback={
        <div className='theme_layout_page_width mx-auto duration-100'>
          <div className='mx-auto w-full max-w-sm'>
            <div className='space-y-4'>
              {Array.from({ length: 6 }).map((_, index) => (
                <SkeletonProductCarousel key={index} />
              ))}
            </div>
          </div>
        </div>
      }
    >
      <ProductCarouselContent
        element={element}
        preview={preview}
        host={host}
        theme={theme}
        storeSetting={storeSetting}
      />
    </Suspense>
  );
}
